"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TdDevExtremeModule = /** @class */ (function () {
    function TdDevExtremeModule() {
    }
    return TdDevExtremeModule;
}());
exports.TdDevExtremeModule = TdDevExtremeModule;
